import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/popover";
import { Calendar } from "../../ui/calendar";
import { T } from "./todoTokens";

const iso = (d) => (d ? new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10) : null);

/* An in-page calendar rather than the browser's native date input — the native
   popup kept closing the field the moment you clicked through to another month. */
export const DueDatePicker = ({ id, value, disabled, children, onPick }) => {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(`${value}T00:00:00`) : undefined;

  const pick = (d) => { setOpen(false); onPick(iso(d)); };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild disabled={disabled}>{children}</PopoverTrigger>
      <PopoverContent align="end" className="w-auto p-0 bg-white border-[#DAD5CA]"
        data-testid={`todo-calendar-${id}`}>
        <Calendar mode="single" selected={selected} defaultMonth={selected} onSelect={(d) => d && pick(d)}
          weekStartsOn={1} initialFocus />
        <div className="flex items-center gap-2 px-3 py-2" style={{ borderTop: `1px solid ${T.rule}` }}>
          <button onClick={() => pick(new Date())} data-testid={`todo-date-today-${id}`}
            className="h-7 px-2 rounded-[6px] text-[12px] font-semibold hover:bg-[#F5F2EA]"
            style={{ color: T.ink }}>Today</button>
          {value && (
            <button onClick={() => { setOpen(false); onPick(null); }} data-testid={`todo-date-clear-${id}`}
              className="h-7 px-2 rounded-[6px] text-[12px] ml-auto hover:bg-[#F5F2EA]"
              style={{ color: T.ink2 }}>Clear date</button>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};
